var Layout = require("enyo-ui/Layout"),
    kind   = require("enyo/kind");

/**
 * Some extra handy utilities for Layouts.
 */
module.exports = kind(/** @lends  app.ui.Layout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Layout",

    /**
     * @private
     */
    kind: Layout,

    // Control Visibility
    // --------------------

    /**
     * Fully hides the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    hideControl: function(control) {
        control.hide();
    },

    /**
     * Ensures the control is displayed in the DOM. It might still be visually
     * hidden, but it will have a working box-model.
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    visuallyHideControl: function(control) {
        // Sometimes Chrome doesn't properly update dimensions when using
        // visibility hidden, so we make sure the control is just *slightly*
        // visible. This forces Chrome to calculate it's properties correctly.
        control.applyStyle("opacity", 0.001);
        control.show();
    },

    /**
     * Fully reveals the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    showControl: function(control) {
        control.applyStyle("opacity", 1);
        control.show();
    },

    // Css Classes
    // --------------------

    /**
     * @param  {enyo.Control}  $control  The control
     * @param  {string}        cssClass  The css class
     * @private
     */
    ensureClass: function($control, cssClass) {
        if (!$control.hasClass(cssClass)) {
            $control.addClass(cssClass);
        }
    },

    /**
     * @param  {enyo.Control}  $control  The control
     * @param  {string}        cssClass  The css class
     * @private
     */
    removeClass: function($control, cssClass) {
        while ($control.hasClass(cssClass)) {
            $control.removeClass(cssClass);
        }
    }

});
